import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * Trims leading/trailing whitespace from text inputs and textareas on blur.
 * Inner spaces are kept as typed.
 */
// ponytail: blur-only. Add keystroke/submit handling only if a real case slips through.
@Directive({
  selector: `input:not([type=password]):not([type=file])[ngModel],
             input:not([type=password]):not([type=file])[formControl],
             input:not([type=password]):not([type=file])[formControlName],
             textarea[ngModel], textarea[formControl], textarea[formControlName]`
})
export class TrimOnBlurDirective {

  constructor(@Optional() private ngControl: NgControl) { }

  @HostListener('blur', ['$event.target'])
  onBlur(el: HTMLInputElement | HTMLTextAreaElement) {
    const trimmed = (el.value || '').trim();
    if (trimmed !== el.value) {
      // setValue keeps view, control and (ngModel) parent binding in sync
      this.ngControl?.control?.setValue(trimmed);
    }
  }

}
